import React from "react";
import { Link } from "react-router-dom";

function DemarchesPopulaires() {
    return (
        <>
            {/** testimonials */}
            <div className="relative">
                <div className="container">
                    <p className="mt-2 sm:mb-10 sm:leading-[60px] text-xl sm:text-3xl font-semibold tracking-tight text-gray-900 text-center">
                        Nos démarches les plus populaires
                    </p>
                    <div className="flex gap-4 flex-wrap justify-center z-50 sm:max-w-[80%] mx-auto">
                        <Link to="/notaire-contrat-mariage" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Contrat de mariage</Link>
                        <Link to="/notaire-pma" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Démarches notariales PMA</Link>
                        <Link to="/notaire-pma" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Reconnaissance conjointe anticipée</Link>
                        <Link to="/notaire-acheteur" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Achat immobilier</Link>
                        <Link to="/notaire-vendeur" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Vente immobilière</Link>
                        <Link to="/notaire-pacs" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Convention de PACS notaire</Link>
                    </div>
                </div>
            </div>
        </>

    );
}

export default DemarchesPopulaires;


